import * as React from 'react';
import { BooleanInput, SimpleForm, TextInput, Title } from 'react-admin';
import { useParams } from 'react-router-dom';
import { Card, CardContent } from '@mui/material';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';
import { IFrbsUserRecord, IUpdateUserClaimsProps } from './types';

const getUserCall = httpsCallable<string, IFrbsUserRecord>(functions, 'getUserCall');
const updateUserCall = httpsCallable<IUpdateUserClaimsProps>(functions, 'updateUserCall');

const updateUser = async (props: unknown) => {
  const data = props as IUpdateUserClaimsProps;
  console.log('-- about to updateUser', data);
  await updateUserCall(data);
  console.log('-- updateUser done', data);
};

export const UserEdit = () => {
  const [record, setRecord] = React.useState<IFrbsUserRecord>();
  const { uid } = useParams();
  console.log('---- uid ', uid);

  React.useEffect(() => {
    const doit = async () => {
      const user = await getUserCall(uid);
      setRecord(user.data);
    };
    doit();
  }, [uid]);

  console.log('---rec ', record);
  return (
    <Card>
      <Title title="Edit User" />
      <CardContent>
        <SimpleForm onSubmit={updateUser} record={record}>
          <TextInput source="displayName" disabled />
          <TextInput source="email" disabled />
          <TextInput source="uid" disabled />
          <TextInput source="customClaims.expo" disabled />
          <BooleanInput source="customClaims.roles.userAdmin" disabled />
          <BooleanInput source="customClaims.roles.config" />
          <BooleanInput source="customClaims.roles.pushNotifs" />
          <BooleanInput source="customClaims.roles.settings" />
          <BooleanInput source="customClaims.roles.dataEntry" />
        </SimpleForm>
      </CardContent>
    </Card>
  );
};
